import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LoadingFallback from "../../components/LoadingFallback/LoadingFallback";

// Lazy load route components for code splitting
const HomePage3 = lazy(() => import("../HomePage3/HomePage3"));
const GalleryPage = lazy(() => import("../GalleryPage/GalleryPage"));
const AIIntelligencePage = lazy(
  () => import("../AIIntelligencePage/AIIntelligencePage"),
);
const ContactUsPage = lazy(() => import("../ContactUsPage/ContactUsPage"));
const PrivacyPolicyPage = lazy(
  () => import("../PrivacyPolicyPage/PrivacyPolicyPage"),
);
const TermsConditionPage = lazy(
  () => import("../TermsConditionPage/TermsConditionPage"),
);

const DeleteAccountPage = lazy(
  () => import("../DeleteAccountPage/DeleteAccountPage"),
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage3 />} />
            <Route path="home_pepecoin" element={<HomePage3 />} />
            <Route path="knowledge-think" element={<GalleryPage />} />
            <Route path="ai" element={<AIIntelligencePage />} />
            <Route path="contact-us" element={<ContactUsPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="terms-condition" element={<TermsConditionPage />} />
            <Route path="delete-account" element={<DeleteAccountPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
